// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"index_btnGroup__1i6NF"};